module.exports = __webpack_public_path__ + "img/a0302ed.png";